import routes from '@/constants/routes';
import {
  getAction,
  INIT,
} from '@/store/user/actions';

const EXCLUDED_MOUNTED_ROUTE_CHECKS = [
  routes.soldData,
  routes.marketData,
  routes.comparables,
];

export default {
  async mounted() {
    const { path } = this.$route;

    if (!EXCLUDED_MOUNTED_ROUTE_CHECKS.includes(path)) {
      await this.checkAuthAndRedirect();
    }
  },
  methods: {
    async checkAuthAndRedirect() {
      const user = await this.$store.dispatch(getAction(INIT));

      if (!user.isAuthenticated) {
        await this.$router.push(`${routes.login}?referrer=${encodeURIComponent(this.$route.fullPath)}`);

        return false;
      }

      return true;
    },
  },
};
